"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectSelectedPlanVariant = exports.selectSelectedPlanId = exports.selectSelectedPlan = exports.selectSelectedHandsetVariant = exports.selectSelectedHandsetId = exports.selectSelectedHandset = exports.selectSelectedBusinessSolutionVariant = exports.selectSelectedBusinessSolutionId = exports.selectSelectedBusinessSolution = exports.selectSelectedBroadbandVariant = exports.selectSelectedBroadbandId = exports.selectSelectedBroadband = exports.selectRecommendationsSteps = exports.selectRecommendationRawData = exports.selectRecommendationProductOfferings = exports.selectRecommendationPlans = exports.selectRecommendationHandsets = exports.selectRecommendationCurrentStep = exports.selectRecommendationBusinessSolutions = exports.selectRecommendationBroadbands = exports.selectPlan = exports.selectIsRecommendationFetched = exports.selectHandset = exports.selectBusinessSolution = exports.selectBroadband = void 0;
var _constants = require("../../utils/constants");
var selectRecommendationRawData = function selectRecommendationRawData(state) {
  return state.drools.recommendation.recommendationRawData;
};
exports.selectRecommendationRawData = selectRecommendationRawData;
var selectIsRecommendationFetched = function selectIsRecommendationFetched(state) {
  return state.drools.recommendation.isRecommendationFetched;
};

/**
 * Handset selectors
 */
exports.selectIsRecommendationFetched = selectIsRecommendationFetched;
var selectRecommendationHandsets = function selectRecommendationHandsets(state) {
  return state.drools.recommendation.handsets;
};
exports.selectRecommendationHandsets = selectRecommendationHandsets;
var selectHandset = function selectHandset(state, tier) {
  var handsets = selectRecommendationHandsets(state);
  return handsets.find(function (handset) {
    return handset.tier === tier;
  });
};
exports.selectHandset = selectHandset;
var selectSelectedHandset = function selectSelectedHandset(state) {
  var handsets = selectRecommendationHandsets(state);
  var selectedHandsetId = selectSelectedHandsetId(state);
  return handsets.find(function (handset) {
    return handset.productId === selectedHandsetId;
  });
};
exports.selectSelectedHandset = selectSelectedHandset;
var selectSelectedHandsetVariant = function selectSelectedHandsetVariant(state) {
  var _selectSelectedHandse;
  return (_selectSelectedHandse = selectSelectedHandset(state)) === null || _selectSelectedHandse === void 0 ? void 0 : _selectSelectedHandse.selectedVariant;
};
exports.selectSelectedHandsetVariant = selectSelectedHandsetVariant;
var selectSelectedHandsetId = function selectSelectedHandsetId(state) {
  var recommendedHandset = selectHandset(state, _constants.RECOMMENDATION_TIER.RECOMMENDED);
  return state.drools.recommendation.selectedHandsetId || (recommendedHandset === null || recommendedHandset === void 0 ? void 0 : recommendedHandset.productId);
};

/**
 * Plan selectors
 */
exports.selectSelectedHandsetId = selectSelectedHandsetId;
var selectRecommendationPlans = function selectRecommendationPlans(state) {
  return state.drools.recommendation.plans;
};
exports.selectRecommendationPlans = selectRecommendationPlans;
var selectPlan = function selectPlan(state, tier) {
  var plans = selectRecommendationPlans(state);
  return plans.find(function (plan) {
    return plan.tier === tier;
  });
};
exports.selectPlan = selectPlan;
var selectSelectedPlan = function selectSelectedPlan(state) {
  var plans = selectRecommendationPlans(state);
  var selectedPlanId = selectSelectedPlanId(state);
  return plans.find(function (plan) {
    return plan.productId === selectedPlanId;
  });
};
exports.selectSelectedPlan = selectSelectedPlan;
var selectSelectedPlanVariant = function selectSelectedPlanVariant(state) {
  var _selectSelectedPlan;
  return (_selectSelectedPlan = selectSelectedPlan(state)) === null || _selectSelectedPlan === void 0 ? void 0 : _selectSelectedPlan.selectedVariant;
};
exports.selectSelectedPlanVariant = selectSelectedPlanVariant;
var selectSelectedPlanId = function selectSelectedPlanId(state) {
  var recommendedPlan = selectPlan(state, _constants.RECOMMENDATION_TIER.RECOMMENDED);
  return state.drools.recommendation.selectedPlanId || (recommendedPlan === null || recommendedPlan === void 0 ? void 0 : recommendedPlan.productId);
};
exports.selectSelectedPlanId = selectSelectedPlanId;
var selectRecommendationsSteps = function selectRecommendationsSteps(state) {
  return state.drools.recommendation.steps;
};
exports.selectRecommendationsSteps = selectRecommendationsSteps;
var selectRecommendationCurrentStep = function selectRecommendationCurrentStep(state) {
  return state.drools.recommendation.currentStep;
};

/**
 * Broadband selectors
 */
exports.selectRecommendationCurrentStep = selectRecommendationCurrentStep;
var selectRecommendationBroadbands = function selectRecommendationBroadbands(state) {
  return state.drools.recommendation.broadbands;
};
exports.selectRecommendationBroadbands = selectRecommendationBroadbands;
var selectBroadband = function selectBroadband(state, tier) {
  var broadbands = selectRecommendationBroadbands(state);
  return broadbands.find(function (broadbands) {
    return broadbands.tier === tier;
  });
};
exports.selectBroadband = selectBroadband;
var selectSelectedBroadband = function selectSelectedBroadband(state) {
  var broadbands = selectRecommendationBroadbands(state);
  var selectedBroadbandId = selectSelectedBroadbandId(state);
  return broadbands.find(function (broadband) {
    return broadband.productId === selectedBroadbandId;
  });
};
exports.selectSelectedBroadband = selectSelectedBroadband;
var selectSelectedBroadbandVariant = function selectSelectedBroadbandVariant(state) {
  var _selectSelectedBroadb;
  return (_selectSelectedBroadb = selectSelectedBroadband(state)) === null || _selectSelectedBroadb === void 0 ? void 0 : _selectSelectedBroadb.selectedVariant;
};
exports.selectSelectedBroadbandVariant = selectSelectedBroadbandVariant;
var selectSelectedBroadbandId = function selectSelectedBroadbandId(state) {
  var recommendedBroadband = selectBroadband(state, _constants.RECOMMENDATION_TIER.RECOMMENDED);
  return state.drools.recommendation.selectedBroadbandId || (recommendedBroadband === null || recommendedBroadband === void 0 ? void 0 : recommendedBroadband.productId);
};
/**
 * Business solution selectors
 */
exports.selectSelectedBroadbandId = selectSelectedBroadbandId;
var selectRecommendationBusinessSolutions = function selectRecommendationBusinessSolutions(state) {
  return state.drools.recommendation.businessSolutions;
};
exports.selectRecommendationBusinessSolutions = selectRecommendationBusinessSolutions;
var selectBusinessSolution = function selectBusinessSolution(state, tier) {
  var businessSolutions = selectRecommendationBusinessSolutions(state);
  return businessSolutions.find(function (businessSolutions) {
    return businessSolutions.tier === tier;
  });
};
exports.selectBusinessSolution = selectBusinessSolution;
var selectSelectedBusinessSolution = function selectSelectedBusinessSolution(state) {
  var businessSolutions = selectRecommendationBusinessSolutions(state);
  var selectedBusinessSolutionId = selectSelectedBusinessSolutionId(state);
  return businessSolutions.find(function (businessSolution) {
    return businessSolution.productId === selectedBusinessSolutionId;
  });
};
exports.selectSelectedBusinessSolution = selectSelectedBusinessSolution;
var selectSelectedBusinessSolutionVariant = function selectSelectedBusinessSolutionVariant(state) {
  var _selectSelectedBusine;
  return (_selectSelectedBusine = selectSelectedBusinessSolution(state)) === null || _selectSelectedBusine === void 0 ? void 0 : _selectSelectedBusine.selectedVariant;
};
exports.selectSelectedBusinessSolutionVariant = selectSelectedBusinessSolutionVariant;
var selectSelectedBusinessSolutionId = function selectSelectedBusinessSolutionId(state) {
  var recommendedBusinessSolution = selectBusinessSolution(state, _constants.RECOMMENDATION_TIER.RECOMMENDED);
  return state.drools.recommendation.selectedBusinessSolutionsId || (recommendedBusinessSolution === null || recommendedBusinessSolution === void 0 ? void 0 : recommendedBusinessSolution.productId);
};

/**
 * Relationship products selectors
 */
exports.selectSelectedBusinessSolutionId = selectSelectedBusinessSolutionId;
var selectRecommendationProductOfferings = function selectRecommendationProductOfferings(state) {
  return state.drools.productCatalog.productRelationshipOffering;
};
exports.selectRecommendationProductOfferings = selectRecommendationProductOfferings;